import { motion } from "motion/react";
import { useSectionParallax } from "../../../hooks/useSectionParallax";
import { AssistantActivity } from "../AssistantActivity";

const MERLIN_STEPS = [
  "Previewed dataset.parquet",
  "Profiled columns and missing values",
  "Proposed: new page “Correlations”",
  "Approve & Run: page executed",
];

const POINTS = [
  { title: "Manual mode.", body: "Merlin proposes each new page or edit. You approve, Approve & Run, or deny." },
  { title: "Auto mode.", body: "Flip the toggle and Merlin creates pages, runs them, and reads the output on its own." },
  { title: "Works from your files.", body: "Merlin previews, profiles, and reads metadata from your project files, and can request package installs." },
  { title: "Skills.", body: "Save reusable instructions and apply them to any conversation. Merlin can suggest saving one." },
];

export function MeetMerlin() {
  const { ref, bgY, fgY } = useSectionParallax();
  return (
    <div ref={ref} className="grid lg:grid-cols-2 gap-14 items-center">
      <motion.div style={{ y: fgY }}>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#1E4FD8] dark:text-[#4A90D9] mb-3">Notebook · AI Assistant</p>
        <h3 className="text-3xl font-normal tracking-[-0.02em] text-[#0A0A0F] dark:text-white mb-8">Meet Merlin.</h3>
        <div className="space-y-5">
          {POINTS.map(({ title, body }) => (
            <div key={title}>
              <p className="text-sm font-medium text-[#0A0A0F] dark:text-white">{title}</p>
              <p className="text-sm text-[#5C5C66] dark:text-[#9A9A9A] mt-1">{body}</p>
            </div>
          ))}
        </div>
      </motion.div>
      <motion.div style={{ y: bgY }}>
        <AssistantActivity
          name="Merlin" status="Executing" accentCls="text-[#1E4FD8] dark:text-[#4A90D9]"
          prompt="Profile this dataset and visualize the most interesting relationship."
          steps={MERLIN_STEPS}
          trailing="Reading the output..."
        />
      </motion.div>
    </div>
  );
}
